import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  FetchTenderByIdDocument,
  RequestMarginDecisionOnTenderMutation,
  RequestMarginDecisionOnTenderMutationVariables,
  RequestMarginDecisionOnTenderDocument,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";

/**
 * Custom hook for requesting margin approval on tender and handling the necessary cache updates.
 * @returns {Object} - Contains the requestMarginDecisionOnTender function, loading state, and error state.
 */
export default function useRequestMarginDecisionOnTenderMutationHook(): {
  requestMarginDecisionOnTender: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [requestMarginDecisionOnTender, { loading, error }] = useMutation<RequestMarginDecisionOnTenderMutation, RequestMarginDecisionOnTenderMutationVariables>(
    RequestMarginDecisionOnTenderDocument, {
      onCompleted: () => {
        toast(CustomToastComponent, {
          toastId: "margin-decision-requested-tender-success",
          data: {
            title: t("toasts.approvalrequestsent"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTenderByIdDocument,
          variables: { id: Number(tenderID) },
        },
      ],
    });

  return {
    requestMarginDecisionOnTender,
    loading,
    error,
  };
}
